const QuerySearchReport = {
   'date': '',
   'id': '',
   'items': {
       'top_answer': '',
       'other_answers': [
               {
                   'document': 'a-vision-for-publicly-funded-legal-aid-in-british-columbia',
                   'highlight': '<b class="search-result">the Law Society’s efforts to  educate, inspire and lead on legal aid reform in British Columbia.            DM1442171  21    Appendix 1:      The Law Society’s Vision for Public Legal Aid in British  Columbia  WHEREAS    The rule of law is the foundation of our democratic society. Every person mus</b>',
                   'highlight_phrase': ['the Law Society’s efforts to  educate, inspire and lead on legal aid reform in British Columbia.            DM1442171  21    Appendix 1:      The Law Society’s Vision for Public Legal Aid in British  Columbia  WHEREAS    The rule of law is the foundation of our democratic society. Every person mus'],
                   'id': '',
                   'page': ['20']
               },
               {
                   'document': 'a-vision-for-publicly-funded-legal-aid-in-british-columbia',
                   'highlight': '<b class="search-result">33. Legal aid is about more than systems and services, funding and programs – it is a public good.   This point was made forcefully at the Colloquium and the Task Force reiterates it as a statement  of policy that informs its thinking.  The presence of a strong legal aid system can transform lives  </b>',
                   'highlight_phrase': [
                       '33. Legal aid is about more than systems and services, funding and programs – it is a public good.   This point was made forcefully at the Colloquium and the Task Force reiterates it as a statement  of policy that informs its thinking.  The presence of a strong legal aid system can transform lives  '
                    ],
                   'id': '',
                   'page': ['10']
               },
               {
                   'document': 'a-vision-for-publicly-funded-legal-aid-in-british-columbia',
                   'highlight': '...at a shared  understanding of the role of <b class="search-result">legal</b> <b class="search-result">aid</b> in society.  What services should <b class="search-result">legal</b> <b class="search-result">aid</b> entail and why?   What are the proper objects of <b class="search-result">legal</b> <b class="search-result">aid</b>?  Only then can we have a meaningful discussion about  how to properly fund <b class="search-result">legal</b> <b class="search-result">aid</b>.    20. Developing a principled, sustainable basis for...',
                   'highlight_phrase': [
                       'legal','aid'],
                   'id': '',
                   'page': ['7']
               },
               {
                   'document': 'LegalAidBC_service-plan',
                   'highlight': '...of <b class="search-result">legal</b> <b class="search-result">aid</b> services and helps demonstrate the importance  of <b class="search-result">legal</b> <b class="search-result">aid</b> in ensuring access to justice for the people of BC.          https://legalaid.bc.ca/about/ourMandate  https://legalaid.bc.ca/about/ourMandate      <b class="search-result">Legal</b> <b class="search-result">Aid</b> BC    2021/22 – 2023/24 Service Plan Page | 17     Objective 4.2...',
                   'highlight_phrase': [
                       'legal','aid'],
                   'id': '',
                   'page': ['16']
               },
               {
                   'document': 'LegalAidBC-Everyday-legal-needs-survey-2020',
                   'highlight': '...System Perceptions 46  Respondent Profile 48        Background, Objectives &  Methodology   3        BACKGROUND & OBJECTIVES   4   <b class="search-result">Legal</b> <b class="search-result">Aid</b> BC (LABC) provides <b class="search-result">legal</b> information, advice and representation services to low income British Columbians facing <b class="search-result">legal</b> problems...',
                   'highlight_phrase': ['legal','aid'],
                   'id': '',
                   'page': ['1']
               },
               {
                   'document': 'Legal-Officer_job-description',
                   'highlight': '...to all the Justices of the Peace within the Province.   • To oversee and conduct training programs for Justices of the Peace.    • To act as <b class="search-result">legal</b> advisor to and participate on various Judicial Committees, as required.   • To provide advice to  judicial officers who are served with <b class="search-result">legal</b>...',
                   'highlight_phrase': ['legal','legal'],
                   'id': '',
                   'page': ['2']
               },
        ]
   },
   'keyword': '',
   'project_id': '',
   'report_name': '',
   'type': '',
   'user_id': ''
}
export default QuerySearchReport;